import React, { useState } from 'react';
import { toast } from 'react-toastify';

const AddRoomTypeModal = ({ isOpen, onClose, onSaveRoomType }) => {
  const [typeName, setTypeName] = useState('');
  const [status, setStatus] = useState('Active');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!typeName.trim()) {
      toast.error('Please enter a room type name');
      return;
    }

    onSaveRoomType({
      id: Date.now(),
      name: typeName.trim(),
      status: status
    });

    toast.success(`Room Type "${typeName.trim()}" added successfully!`);
    setTypeName('');
    onClose();
  };

  return (
    <div className="manage-modal-backdrop" onClick={onClose}>
      <div className="manage-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="manage-modal-header">
          <h3>🛏️ Add New Room Type</h3>
          <button className="manage-modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="manage-modal-body">
            <div className="modal-form-group">
              <label>* Room Type Name</label>
              <input
                type="text"
                placeholder="e.g. General Ward, ICU, Non-AC Room, VIP Suite"
                value={typeName}
                onChange={(e) => setTypeName(e.target.value)}
                autoFocus
              />
            </div>

            <div className="modal-form-group">
              <label>* Status</label>
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <div className="manage-modal-footer">
            <button type="button" className="modal-btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="modal-btn-save">Save Room Type</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddRoomTypeModal;
